import { createTheme } from "@mui/material";


const formControlStyle = createTheme({
    components: {
        MuiFormControl: {
            styleOverrides: {
                root: {
                    marginBottom: '12px',
                    '& .MuiOutlinedInput-root': {
                        '& input': {
                            padding: '12px 16px',
                        },
                        '& fieldset': {
                            borderColor: '#E1E1E0',
                            borderWidth: '1px',
                            borderRadius: '8px'
                        },
                        '&:hover fieldset': {
                            borderColor: '#A77BCA',
                            borderWidth: '1px',
                        },
                        '&.Mui-disabled fieldset': {
                            borderColor: '#D8D8D8',
                            backgroundColor: '#F9F9F9'
                        },
                        '&.Mui-disabled:hover fieldset': {
                            borderColor: '#D8D8D8',
                            backgroundColor: '#F9F9F9',
                        },
                        '&.Mui-focused fieldset': {
                            // borderColor: '#A77BCA',
                            // borderWidth: '1.5px',
                            border: 'none',
                            boxShadow: '0 0 0 3px #E5D7EF'
                        },
                        '&.Mui-error fieldset': {
                            borderColor: '#d32f2f',
                            borderWidth: '1.5px',
                        },
                    },
                },
            },
        },
    },
});

// Normal Form Textfield customized based on latest themes
const InputField = createTheme({
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        '& input': {
                            padding: '8px 12px',
                            fontSize: 13,                        
                            '::placeholder': {
                                color: '#7F7F7F',
                            },
                        },
                        '& fieldset': {
                            // borderColor: '#E1E1E0',
                            // borderWidth: '1px',
                            borderRadius: '8px'
                        },
                        // '&.Mui-disabled': {
                        //     background: '#F5F5F5',
                        //     borderColor: '#D8D8D8'
                        // },
                        // '&.Mui-disabled fieldset': {
                        //     borderWidth: '1px',
                        //     borderColor: '#D8D8D8'
                        // },
                        // '&.Mui-disabled:hover fieldset': {
                        //     borderColor: '#D8D8D8'
                        // },
                        // '&:hover fieldset': {
                        //     borderColor: '#A77BCA',
                        //     borderWidth: '1px',
                        // },
                        // '&.Mui-focused fieldset': {
                        //     border: 'none',
                        //     boxShadow: '0 0 0 2.5px #E5D7EF',
                        //     borderWidth: '1px',
                        // },
                        // '&.Mui-error fieldset': {
                        //     borderColor: '#d32f2f',
                        //     borderWidth: '1px',
                        // },
                    },
                },
            },
        },
    },
})
//Form Select Textfield
const InputSelectField = createTheme({
    components: {
        MuiSelect: {
            styleOverrides: {
                root: {
                    '&.MuiInputBase-root ': {
                        '& .MuiSelect-select': {
                            padding: '8px 12px',
                            fontSize: 14
                        },
                        '& fieldset': {
                            borderColor: '#E1E1E0',
                            borderWidth: '1px',
                            borderRadius: '8px'
                        },
                        '&:hover fieldset': {
                            borderColor: '#A77BCA',
                            borderWidth: '1px',
                        },
                        '&.Mui-disabled': {
                            background: '#F5F5F5',
                            borderColor: '#D8D8D8'
                        },
                        '&.Mui-disabled fieldset': {
                            borderWidth: '1px',
                            borderColor: '#D8D8D8'
                        },
                        '&.Mui-disabled:hover fieldset': {
                            borderColor: '#D8D8D8'
                        },
                        '&.Mui-focused fieldset': {
                            border: 'none',
                            boxShadow: '0 0 0 2.5px #E5D7EF',
                            borderWidth: '1px',
                        },
                        '&.Mui-error fieldset': {
                            borderColor: '#d32f2f',
                            borderWidth: '1px',
                        },
                    },
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        }
    }
})
//Form Search Textfield
const InputSearchField = createTheme({
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        '& input': {
                            padding: '8px 12px',
                            fontSize: 14,
                            '::placeholder': {
                                color: '#7F7F7F',
                                opacity: 1
                            },
                        },
                        '& fieldset': {
                            borderColor: '#E1E1E0',
                            borderWidth: '1px',
                            borderRadius: '8px'
                        },
                        '&.Mui-disabled': {
                            background: '#F5F5F5',
                            borderColor: '#D8D8D8'
                        },
                        '&.Mui-disabled fieldset': {
                            borderWidth: '1px',
                            borderColor: '#D8D8D8'
                        },
                        '&.Mui-disabled:hover fieldset': {
                            borderColor: '#D8D8D8'
                        },
                        '&:hover fieldset': {
                            borderColor: '#A77BCA',
                            borderWidth: '1px',
                        },
                        '&.Mui-focused fieldset': {
                            border: 'none',
                            boxShadow: '0 0 0 2.5px #E5D7EF',
                            borderWidth: '1px',
                        },
                        '&.Mui-error fieldset': {
                            borderColor: '#d32f2f',
                            borderWidth: '1px',
                        },
                    },
                }
            }
        }
    }
})

// Mui Autocomplete  customized based on latest theme
const InputAutoComplete = createTheme({
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    // width: '100%',
                    '& .MuiInputBase-root': {
                        padding: '0 12px',
                        // '&:hover .MuiOutlinedInput-notchedOutline': {
                        //     borderColor: '#A77BCA',
                        //     borderWidth: '1px',
                        // },
                        '&.Mui-disabled .MuiAutocomplete-endAdornment ': {
                            display: 'none',
                          },
                    },
                    '& fieldset': {                      
                        borderRadius: '8px'
                    },
                   
                    // '&.Mui-disabled': {
                    //     background: '#F5F5F5',
                    //     borderColor: '#D8D8D8'
                    // },
                    // '&.Mui-disabled fieldset': {
                    //     borderWidth: '1px',
                    //     borderColor: '#D8D8D8'
                    // },
                    // '&.Mui-disabled:hover fieldset': {
                    //     borderColor: '#D8D8D8'
                    // },
                    // '&.Mui-focused fieldset': {
                    //     border: 'none',
                    //     boxShadow: '0 0 0 2.5px #E5D7EF',
                    //     borderWidth: '1px',
                    // },
                    // '&.Mui-error fieldset': {
                    //     borderColor: '#d32f2f',
                    //     borderWidth: '1px',
                    // },
                }
            }
        }
    }
})

const DatePickerStyledTheme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    // fontWeight: 400,                   
                    '&.MuiInputBase-root': {
                        '& input': {
                            padding: '8px 12px',
                            fontSize: 14,
                            '::placeholder': {
                                color: '#7F7F7F',
                                opacity: 1
                            },
                        },
                    },                   
                    '& fieldset': {
                        borderColor: '#E1E1E0',
                        borderWidth: '1px',
                        borderRadius: '8px'
                    },
                    '&.Mui-disabled': {
                        background: '#F5F5F5',
                        borderColor: '#D8D8D8'
                    },
                    '&.Mui-disabled fieldset': {
                        borderWidth: '1px',
                        borderColor: '#D8D8D8'
                    },
                    '&.MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline ': {
                        borderColor: '#A77BCA',
                        borderWidth: '1px',
                    },
                    '&.Mui-focused fieldset': {
                        border: 'none',
                        boxShadow: '0 0 0 2.5px #E5D7EF',
                        borderWidth: '1px',
                    },
                    '&.Mui-error fieldset': {
                        borderColor: '#d32f2f',
                        borderWidth: '1px',
                    },

                }
            }
        }
    }
})

export { formControlStyle, InputField, InputSelectField, InputSearchField, InputAutoComplete, DatePickerStyledTheme }